import appGlobalScript from '/tmp/scratch/ticom-feature-components_62zru/src/global/index.ts';
export const globalScripts = appGlobalScript;
